import ConversationPage from "./ConversationPage";

export default ConversationPage;
